// 是否本地开发环境
export function isDev() {
  // return process.env.NODE_ENV == 'development'
  return (
    process.env.NODE_ENV == 'development' || /(\d+.){3}\d|localhost|test/.test(location.hostname)
  )
}
// 是否test-mx测试环境
export function isTest() {
  return document.body.classList.contains('js-is-test')
}
// 是否debug-mx测试环境
export function isDebug() {
  return document.body.classList.contains('js-is-debug')
}
//获取url参数
export function getURLParam(name, url) {
  url = url || window.location.href
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = (url.split('?')[1] || '').split('#')[0].match(reg)
  if (r === null) {
    //search为空则从hash中找
    var reg2 = /^.*?[?]/
    var r2 = (url.split('#')[1] || '').replace(reg2, '')
    r = r2.match(reg)
  }
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export function getNetworkType() {
  var ua = navigator.userAgent
  var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
  networkStr = networkStr.toLowerCase().replace('nettype/', '')
  var networkType
  switch (networkStr) {
    case 'wifi':
      networkType = 'wifi'
      break
    case '4g':
      networkType = '4g'
      break
    case '3g':
      networkType = '3g'
      break
    case '3gnet':
      networkType = '3g'
      break
    case '2g':
      networkType = '2g'
      break
    default:
      networkType = 'other'
  }
  return networkType
}

export function processImgURL(url, param = '') {
  if (!url) return ''
  if (!url.startsWith('http') && !url.startsWith('//')) url = 'https://mxpic.muccyapi.com/' + url
  url = url.replace('http://', 'https://')
  let arr = url.split('?')
  return arr[0] + param + (arr[1] ? '?' + arr[1] : '')
}

/**
 * 使用示例
    animateCSS('.my-element', 'bounce')
    // or
    animateCSS('.my-element', 'bounce', function() {
      // Do something after animation
    })
 */
export function animateCSS(element, animationName, callback) {
  const node = typeof element === 'string' ? document.querySelector(element) : element
  node.classList.add('animated', animationName)

  function handleAnimationEnd() {
    node.classList.remove('animated', animationName)
    node.removeEventListener('animationend', handleAnimationEnd)

    if (typeof callback === 'function') callback()
  }

  node.addEventListener('animationend', handleAnimationEnd)
}

export function isInViewPort(el) {
  const viewPortHeight =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  const top = el.getBoundingClientRect() && el.getBoundingClientRect().top
  // console.log('top', top)
  return top <= viewPortHeight - 100
}

export function toast(params) {
  let config = {
    message: '',
    duration: 2000,
    className: '',
    position: ''
  }
  if (typeof params === 'object') Object.assign(config, params)
  else config.message = params
  let { message, duration, className, position } = config
  let dom = document.createElement('div')
  dom.classList.add('gb-toast')
  if (position) dom.classList.add(`gb-toast-${position}`)
  className.split(' ').forEach(d => d && dom.classList.add(d))
  let html = `${message}`
  dom.innerHTML = html
  let setFn = v => (dom.style.opacity = v)
  setFn(0)
  document.body.appendChild(dom)
  setTimeout(() => setFn(1))
  setTimeout(() => {
    setFn(0)
    setTimeout(() => document.body.removeChild(dom), 300)
  }, duration + 300)
}

/**
 * Parse lrc, suppose multiple time tag
 * @see https://github.com/MoePlayer/APlayer/blob/master/src/js/lrc.js#L83
 * @author DIYgod(https://github.com/DIYgod)
 *
 * @param {String} lrc_s - Format:
 * [mm:ss]lyric
 * [mm:ss.xx]lyric
 * [mm:ss.xxx]lyric
 * [mm:ss.xx][mm:ss.xx][mm:ss.xx]lyric
 * [mm:ss.xx]<mm:ss.xx>lyric
 *
 * @return {String} [[time, text], [time, text], [time, text], ...]
 */
export function parseLrc(lrc_s) {
  if (lrc_s) {
    lrc_s = lrc_s.replace(/([^\]^\n])\[/g, (match, p1) => p1 + '\n[')
    const lyric = lrc_s.split('\n')
    const lrc = []
    const lyricLen = lyric.length
    for (let i = 0; i < lyricLen; i++) {
      // match lrc time
      const lrcTimes = lyric[i].match(/\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g)
      // match lrc text
      const lrcText = lyric[i]
        .replace(/.*\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g, '')
        .replace(/<(\d{2}):(\d{2})(\.(\d{2,3}))?>/g, '')
        .replace(/^\s+|\s+$/g, '')

      if (lrcTimes) {
        // handle multiple time tag
        const timeLen = lrcTimes.length
        for (let j = 0; j < timeLen; j++) {
          const oneTime = /\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/.exec(lrcTimes[j])
          const min2sec = oneTime[1] * 60
          const sec2sec = parseInt(oneTime[2])
          const msec2sec = oneTime[4]
            ? parseInt(oneTime[4]) / ((oneTime[4] + '').length === 2 ? 100 : 1000)
            : 0
          const lrcTime = min2sec + sec2sec + msec2sec
          lrc.push([lrcTime, lrcText])
        }
      }
    }
    // sort by time
    lrc.sort((a, b) => a[0] - b[0])
    return lrc
  } else {
    return []
  }
}

export function initSensors() {
  ; (function (para) {
    var p = para.sdk_url,
      n = para.name,
      w = window,
      d = document,
      s = 'script',
      x = null,
      y = null
    if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
      return false
    }
    w['sensorsDataAnalytic201505'] = n
    w[n] =
      w[n] ||
      function (a) {
        return function () {
          ; (w[n]._q = w[n]._q || []).push([a, arguments])
        }
      }
    var ifs = [
      'track',
      'quick',
      'register',
      'registerPage',
      'registerOnce',
      'trackSignup',
      'trackAbtest',
      'setProfile',
      'setOnceProfile',
      'appendProfile',
      'incrementProfile',
      'deleteProfile',
      'unsetProfile',
      'identify',
      'login',
      'logout',
      'trackLink',
      'clearAllRegister',
      'getAppStatus'
    ]
    for (var i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i])
    }
    if (!w[n]._t) {
      ; (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0])
      x.async = 1
      x.src = p
      x.setAttribute('charset', 'UTF-8')
      y.parentNode.insertBefore(x, y)
      w[n].para = para
    }
  })({
    sdk_url: `https://mx.muccybook.com/static/sensorsdata.min.js`,
    heatmap_url: `https://mx.muccybook.com/static/heatmap.min.js`,
    name: 'sensors',
    server_url: 'https://fx-it.66rpg.com:8206/sa?project=muxi',
    corss_subdomain: false,
    show_log: false,
    heatmap: {},
    use_app_track: false
  })
}

// 加密算法
export function ut_encryptXor(data = {}) {
  // console.log("data", data);
  data = {
    ...data,
    timestamp: parseInt(new Date().getTime() / 1000)
  }
  let text = JSON.stringify(data)
  var _tempStr = '';
  let encryptStr = "brv@eeLzXaXdHDdq"
  for (var i = 0; i < text.length; i++) {
    _tempStr += String.fromCharCode(text.charCodeAt(i) ^ encryptStr.charCodeAt(i % encryptStr.length));
  }
  // eslint-disable-next-line no-redeclare
  var hex, i;
  var result = "";
  for (i = 0; i < _tempStr.length; i++) {
    hex = _tempStr.charCodeAt(i).toString(16);
    result += ("0" + hex).slice(-2);
  }
  return result;
}
